document.addEventListener('DOMContentLoaded', function () {
    const sliderWrapper = document.querySelector('.slider-wrapper');
    const slides = document.querySelectorAll('.slider-item');
    const prevSlideButton = document.querySelector('.prev-slide');
    const nextSlideButton = document.querySelector('.next-slide');

    let currentSlide = 0;
    const totalSlides = slides.length;

    function showSlide(index) {
        if (index >= totalSlides) {
            currentSlide = 0;
        } else if (index < 0) {
            currentSlide = totalSlides - 1;
        } else {
            currentSlide = index;
        }
        sliderWrapper.style.transform = `translateX(-${currentSlide * 100}%)`;
    }

    nextSlideButton.addEventListener('click', () => {
        showSlide(currentSlide + 1);
    });

    prevSlideButton.addEventListener('click', () => {
        showSlide(currentSlide - 1);
    });

    // Initial display
    showSlide(currentSlide);
});

/*AS - jun-24 - cart attributes for product vendors*/
// Shopify Cart Vendor Tracking Script
// Run this script on every page load to track product names and vendors in cart attributes

(function() {
    'use strict';

    // Configuration
    const CART_ATTRIBUTE_PRODUCTS = 'tracked_products';
    const CART_ATTRIBUTE_VENDORS = 'tracked_vendors';
    const CART_ATTRIBUTE_UPDATED = 'tracking_last_updated';

    /**
     * Get current cart data
     */
    async function getCurrentCart() {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
        }
    }

    /**
     * Extract product names and vendors from cart items
     */
    function extractCartData(cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
            return {
                products: [],
                vendors: [],
                isEmpty: true
            };
        }

        const products = [];
        const vendors = new Set();

        cart.items.forEach(item => {
            // Add product title with quantity info
            const productInfo = `${item.product_title} (${item.variant_title || 'Default'}) x${item.quantity}`;
            products.push(productInfo);

            // Add vendor to set (automatically handles duplicates)
            if (item.vendor) {
                vendors.add(item.vendor);
            }
        });

        return {
            products: products,
            vendors: Array.from(vendors),
            isEmpty: false
        };
    }

    /**
     * Update cart attributes with product and vendor information
     */
    async function updateCartAttributes(cartData) {
        const attributes = {};

        if (cartData.isEmpty) {
            // Clear tracking attributes when cart is empty
            attributes[CART_ATTRIBUTE_PRODUCTS] = '';
            attributes[CART_ATTRIBUTE_VENDORS] = '';
            attributes[CART_ATTRIBUTE_UPDATED] = '';
        } else {
            // Set tracking attributes with current cart data
            attributes[CART_ATTRIBUTE_PRODUCTS] = cartData.products.join(' | ');
            attributes[CART_ATTRIBUTE_VENDORS] = cartData.vendors.join(', ');
            attributes[CART_ATTRIBUTE_UPDATED] = new Date().toISOString();
        }

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ attributes })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const updatedCart = await response.json();
            console.log('Cart attributes updated successfully:', {
                products: cartData.products,
                vendors: cartData.vendors,
                timestamp: attributes[CART_ATTRIBUTE_UPDATED]
            });

            return updatedCart;
        } catch (error) {
            console.error('Error updating cart attributes:', error);
            return null;
        }
    }

    /**
     * Check if cart attributes need updating
     */
    function shouldUpdateAttributes(cart, cartData) {
        if (cartData.isEmpty && (!cart.attributes || !cart.attributes[CART_ATTRIBUTE_PRODUCTS])) {
            // Cart is empty and no tracking attributes exist - no update needed
            return false;
        }

        if (cartData.isEmpty) {
            // Cart is empty but tracking attributes exist - need to clear them
            return true;
        }

        // Check if current products/vendors match stored attributes
        const storedProducts = cart.attributes[CART_ATTRIBUTE_PRODUCTS] || '';
        const storedVendors = cart.attributes[CART_ATTRIBUTE_VENDORS] || '';
        
        const currentProducts = cartData.products.join(' | ');
        const currentVendors = cartData.vendors.join(', ');

        return storedProducts !== currentProducts || storedVendors !== currentVendors;
    }

    /**
     * Main tracking function
     */
    async function trackCartVendors() {
        console.log('Starting cart vendor tracking...');

        // Get current cart
        const cart = await getCurrentCart();
        if (!cart) {
            console.error('Failed to fetch cart data');
            return;
        }

        // Extract product and vendor data
        const cartData = extractCartData(cart);

        // Check if update is needed
        if (!shouldUpdateAttributes(cart, cartData)) {
            console.log('Cart attributes are up to date, no update needed');
            return;
        }

        // Update cart attributes
        await updateCartAttributes(cartData);
    }

    /**
     * Initialize tracking with error handling and retry logic
     */
    async function initializeTracking() {
        let retryCount = 0;
        const maxRetries = 3;
        const retryDelay = 1000; // 1 second

        while (retryCount < maxRetries) {
            try {
                await trackCartVendors();
                break; // Success, exit retry loop
            } catch (error) {
                retryCount++;
                console.error(`Cart tracking attempt ${retryCount} failed:`, error);
                
                if (retryCount < maxRetries) {
                    console.log(`Retrying in ${retryDelay}ms...`);
                    await new Promise(resolve => setTimeout(resolve, retryDelay));
                } else {
                    console.error('Cart tracking failed after all retry attempts');
                }
            }
        }
    }

    /**
     * Wait for Shopify to be ready
     */
    function waitForShopify() {
        return new Promise((resolve) => {
            if (window.Shopify && window.Shopify.routes) {
                resolve();
            } else {
                // Wait for Shopify to load
                const checkShopify = setInterval(() => {
                    if (window.Shopify && window.Shopify.routes) {
                        clearInterval(checkShopify);
                        resolve();
                    }
                }, 100);

                // Timeout after 10 seconds
                setTimeout(() => {
                    clearInterval(checkShopify);
                    console.warn('Shopify not detected after 10 seconds, proceeding anyway');
                    resolve();
                }, 10000);
            }
        });
    }

    /**
     * Start tracking when page loads
     */
    async function startTracking() {
        // Wait for Shopify to be ready
        await waitForShopify();
        
        // Small delay to ensure everything is loaded
        setTimeout(initializeTracking, 500);
    }

    // Initialize tracking
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startTracking);
    } else {
        startTracking();
    }

    // Optional: Listen for cart changes (useful for AJAX cart updates)
    document.addEventListener('cart:updated', function() {
        console.log('Cart updated event detected, re-tracking vendors...');
        setTimeout(initializeTracking, 100);
    });

    // Optional: Listen for theme-specific cart update events
    document.addEventListener('cart:change', function() {
        console.log('Cart change event detected, re-tracking vendors...');
        setTimeout(initializeTracking, 100);
    });

})();